import CampaignCard from "./CampaignCard";

/*
Purpose:
Displays all available campaigns that creators can promote.

Creators can:
• view campaign details
• open bidding modal
• submit a bid

Later this will fetch campaigns from Django API.
*/

export default function CampaignMarketplace() {

  // Temporary campaign data (later from backend API)
  const campaigns = [
    {
      id: 1,
      title: "Nike Running Shoes",
      budget: 10000,
      bidType: "CPC",
      description: "Promote Nike running shoes to your audience."
    },
    {
      id: 2,
      title: "Smart Watch Launch",
      budget: 15000,
      bidType: "CPM",
      description: "Promote our new smartwatch campaign."
    },
    {
      id: 3,
      title: "Fitness App Promotion",
      budget: 8000,
      bidType: "Fixed",
      description: "Promote fitness app through social media."
    }
  ];

  return (

    <div>

      <h2 className="text-2xl text-black font-bold mb-6">
        Campaign Marketplace
      </h2>

      {/* Campaign Grid */}

      <div className="grid grid-cols-3 gap-6">

        {campaigns.map((campaign) => (
          <CampaignCard
            key={campaign.id}
            campaign={campaign}
          />
        ))}

      </div>

    </div>

  );
}